import { render, staticRenderFns } from "./addselfgroup.vue?vue&type=template&id=a45c8340&scoped=true&"
import script from "./addselfgroup.vue?vue&type=script&lang=js&"
export * from "./addselfgroup.vue?vue&type=script&lang=js&"
import style0 from "./addselfgroup.vue?vue&type=style&index=0&id=a45c8340&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45c8340",
  null
  
)

export default component.exports